import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { PATHS } from "@router/paths";
import { socialLinks } from "@constants/footerSocialLinks";

import SidebarNavItem from "./SidebarNavItem/SidebarNavItem";
import IconLink from "@components/navigation/IconLink/IconLink";

import { ReactComponent as ChatIcon } from "@images/icons/icon-chat.svg";
import { ReactComponent as HeartIcon } from "@images/icons/icon-heart.svg";
import { ReactComponent as StarIcon } from "@images/icons/icon-star.svg";

import "./MainSidebar.scss";

interface MainSidebarProps {
  className?: string;
}

const MainSidebar = ({ className }: MainSidebarProps) => {
  const location = useLocation();
  const { chatId } = useParams();
  const { t } = useTranslation("layout");

  const isChatPath = location.pathname === PATHS.chat.getPath(chatId || "");

  const classes = classNames(`main-sidebar`, className);

  return (
    <div className={classes}>
      <div className="sidebar-actions">
        <SidebarNavItem to={PATHS.main.path} title={t("mainSidebar.actions.grils")}>
          <HeartIcon />
          {t("mainSidebar.actions.grils")}
        </SidebarNavItem>

        <SidebarNavItem to={PATHS.chats.path} title={t("mainSidebar.actions.chat")} active={isChatPath}>
          <ChatIcon />
          {t("mainSidebar.actions.chat")}
        </SidebarNavItem>

        <SidebarNavItem to="#" title={t("mainSidebar.actions.generate")} comingSoon>
          <StarIcon />
          {t("mainSidebar.actions.generate")}
        </SidebarNavItem>
      </div>

      <div className="social-links">
        {socialLinks.map(({ title, href, sidebarIcon }) => (
          <IconLink key={Math.random()} title={title} href={href} target="_blank">
            {sidebarIcon}
          </IconLink>
        ))}
      </div>
    </div>
  );
};

export default MainSidebar;
